import React from 'react'
import VendorJoinus from '../../Components/Vendor/VendorJoinUs/VendorJoinus'
import SectionOne from '../../Components/Vendor/VendorJoinUs/SectionOne'
import SectionTwo from '../../Components/Vendor/VendorJoinUs/SectionTwo'
import SectionThree from '../../Components/Vendor/VendorJoinUs/SectionThree'
import Footer from '../../Components/Vendor/Footer/Footer'

function JoinusPage() {
  return (
    <div>
      <VendorJoinus/>
      <SectionOne/>
      <SectionTwo/>
      <SectionThree/>
      <Footer/>
    </div>
  )
}

export default JoinusPage
